<template>
  <b-modal
    id="bind-agent-to-roles-modal"
    ref="modal"
    header-bg-variant="info"
    header-text-variant="light"
    title="Vincular agente ao(s) cargo(s)"
    size="xl"
    @show="showModal"
    @hidden="hiddenModal"
  >
    <section class="modal-font-family">
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <b-modal
          ref='bind-product-roles'
          id='bind-product-roles'
          hide-footer
          hide-header
          size='xl'
        >
          <section class='modal-font-family bind-product-roles'>
            <b-overlay
              :show='loadingRoles'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-100'
              style='min-height: 150px'
            >
              <section class='d-flex align-content-center justify-content-between header'>
                <section>
                  <p class='title'>
                    Selecione os cargos para vincular a este agente
                  </p>
                </section>

                <section>
                  <b-icon
                    @click="hideModalBindProductRoles()"
                    class='cursor-pointer'
                    font-scale='2.5'
                    icon='x'
                    color='#262626'
                  >
                  </b-icon>
                </section>
              </section>

              <section class="divider my-2 mb-3"></section>

              <section class="roles mb-4 ">
                <b-form-checkbox-group
                  v-model='rolesLegalsearchIds'
                  v-for='(role, i) in roles'
                  :key='i'
                  class='product'
                  size='lg'
                >
                  <b-form-checkbox
                    class=''
                    :value='role._id'
                  >
                    <p class='word-break product-name mt-2 mb-3'>{{ role.name }} {{ role._id }}</p>
                  </b-form-checkbox>

                  <section class="sector-bind pt-2" v-if="role.sectorsRoles && role.sectorsRoles.length > 0">
                    <section class="d-flex align-items-center ">
                      <svg width="15" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_6346_4788)">
                          <path d="M0.5 14L13.5 1" stroke="#022245" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.5 1H13.5V5" stroke="#022245" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9 9.5L13.5 14" stroke="#022245" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.5 14H13.5V10" stroke="#022245" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M5 5.5L0.5 1" stroke="#022245" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_6346_4788">
                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                          </clipPath>
                        </defs>
                      </svg>
                      <p class="mb-0 ml-2 title">Setores vinculados:</p>
                    </section>
                    <ul>
                      <li
                        class="mb-0 sector-name"
                        v-for="(sectorRole, i) in role.sectorsRoles" :key="`${sectorRole._id}_${i}`"
                        v-show="sectorRole.sectors && sectorRole.sectors.length > 0"
                      >
                        Setor: {{ sectorRole.sectors.map(x => x.name).join(', ') }}
                      </li>
                    </ul>
                  </section>
                </b-form-checkbox-group>
              </section>

              <section class="divider my-2 mb-3"></section>

              <section class='d-flex justify-content-between mt-4'>
                <base-button
                  class='w-25 mr-3 btn-cancel'
                  @click='hideModalBindProductRoles()'
                >
                  <span>Cancelar</span>
                </base-button>

                <base-button
                  class='w-75 btn-add'
                  @click='confirmRolesSelection()'
                >
                  <span>Finalizar</span>
                </base-button>
              </section>

              <template v-slot:overlay>
                <div class='text-center loading-spinner'>
                  <b-spinner
                    style='width: 2rem; height: 2rem'
                    variant='primary'
                    label='Large Spinner'
                  ></b-spinner>
                  <h6 class='text-primary'><strong>Buscando cargos...</strong></h6>
                </div>
              </template>
            </b-overlay>
          </section>
        </b-modal>

        <section v-if="newCompanyHierarchyFormat" class="mt-1  pb-3 d-flex justify-content-between align-items-center">
          <button
            class="btn-to-link-role py-2 px-3"
            @click="showModalBindProductRoles()"
          >
            <span>Vincular cargos a este agente</span>
          </button>

          <button
            @click='showModalAddRole()'
            class='btn-add py-2 px-3'
          >
            <span>Criar um novo cargo</span>
          </button>
        </section>

        <section v-if="agent" class="mt-2">
          <div class="d-flex align-items-stretch agent-risk-row">
            <div class="agent-risk-block flex-grow-1" :class="riskHeaderClass">
              <span class="agent-risk-text">{{ model.getsearchId('searchId', agent) }}</span>
            </div>
            <div class="agent-risk-block agent-risk-block--right" :class="riskHeaderClass">
              <span class="agent-risk-text">{{ riskLabel }}</span>
            </div>
          </div>

          <section v-if="rolesLegalsearchIds.length" class="mt-3 selected-roles-summary p-2">
            <h6 class="mb-2 agent-label">Cargos selecionados ({{ rolesLegalsearchIds.length }})</h6>
            <ul class="ml-2">
              <li
                class="mb-0 agent-value"
                v-for="item in selectedRolesNames"
                :key="item"
              >
              <span>
                {{ item }}
              </span>
              </li>
            </ul>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
          </div>
        </template>
      </b-overlay>
    </section>

    <template #modal-footer>
      <section class="w-100 modal-font-family">
        <b-alert show variant="danger" :class="{ hidden: !error }">{{ error }}</b-alert>
        <section class="d-flex justify-content-between w-100">
          <b-button
            :disabled="loading"
            variant="danger"
            class="w-50 mr-1"
            @click="hide()"
          >
            Cancelar
          </b-button>

          <b-button
            :disabled="loading"
            variant="success"
            class="w-50 ml-1"
            @click="submit()"
          >
            Vincular
          </b-button>
        </section>
      </section>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import LegalSearchSummary from '@/models/LegalSearchSummary'

export default {
  name: 'BindAgentToRolesModal',
  props: {
    agent: { type: Object, default: null }
  },
  data() {
    return {
      model: LegalSearchSummary,
      roles: [],
      rolesLegalsearchIds: [],
      boundRoleIds: [],
      loading: false,
      loadingRoles: false,
      newCompanyHierarchyFormat: false,
      dateNewFormatCompanyHierarchy: null,
      legalSearchId: null
    }
  },
  computed: {
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    ...mapGetters('user', {
      user: 'current'
    }),
    error() {
      return this.$store.getters['access/error']
    },
    riskLabel() {
      if (!this.agent) return ''
      if (this.agent.riskType === 'biologico') return 'Risco Biológico'
      if (this.agent.riskType === 'fisico') return 'Risco Físico'
      return 'Risco Químico'
    },
    riskHeaderClass() {
      if (!this.agent) return ''
      if (this.agent.riskType === 'biologico') return 'agent-risk-header--biological'
      if (this.agent.riskType === 'fisico') return 'agent-risk-header--physical'
      return 'agent-risk-header--chemical'
    },
    selectedRolesNames() {
      if (!this.roles.length || !this.rolesLegalsearchIds.length) {
        return []
      }
      return this.roles
        .filter((r) => this.rolesLegalsearchIds.includes(r._id))
        .map((r) => r.name)
    },
  },
  methods: {
    ...mapActions('role', {
      handleGetByCompany: 'handleGetByCompany'
    }),
    ...mapActions('legalSearch', {
      handleBindRolesToLegalSearch: 'handleBindRolesToLegalSearch'
    }),
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    async showModalAddRole() {
      try {
        setTimeout(() => {
          this.$bvModal.show('role')
        }, 100)
      } catch (e) {
        //
      }
    },
    async showModalBindProductRoles() {
      this.$bvModal.show('bind-product-roles')
      this.loadingRoles = true
      await this.getRoles()
      this.loadingRoles = false
    },
    hideModalBindProductRoles() {
      this.$bvModal.hide('bind-product-roles')
    },
    confirmRolesSelection() {
      this.hideModalBindProductRoles()
    },
    async getRoles() {
      if (!this.importedCompany || !this.importedCompany._id) {
        this.roles = []
        return
      }
      const response = await this.handleGetByCompany(this.importedCompany._id)
      this.roles = (response && response.data && response.data.roles) ? response.data.roles : []
    },
    async reloadRoles() {
      await this.getRoles()
    },
    hiddenModal(){
      this.$emit('reset')
    },
    async showModal() {
      try {
        this.loading = true
        const { rolesLegalsearches, legalSearchId } = this.agent || {}
        this.legalSearchId = legalSearchId
        this.rolesLegalsearchIds = rolesLegalsearches?.map((x) => x.roleId) || []
        this.boundRoleIds = [...this.rolesLegalsearchIds]
        this.roles = []
        const { createdAt } = this.importedCompany || {}
        this.newCompanyHierarchyFormat = false
        if (createdAt) {
          this.dateNewFormatCompanyHierarchy = new Date(process.env.VUE_APP_DATE_NEW_FORMAT_COMPANY_HIERARCHY)
          this.newCompanyHierarchyFormat = moment(new Date(createdAt)).isSameOrAfter(moment(this.dateNewFormatCompanyHierarchy))
        }

        await this.getRoles()
      } finally {
        this.loading = false
      }
    },
    async submit() {
      try {
        this.loading = true
        const body = {
          userId: this.user.id,
          legalSearchId: this.legalSearchId,
          roleIds: this.rolesLegalsearchIds
        }
        const { status, message } = await this.handleBindRolesToLegalSearch(body)

        if(status === 200){
          this.$bvToast.toast( message ? message :'Agente vinculado aos cargos com sucesso.',
            {
              title: 'Sucesso',
              variant: 'success',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 4000
            }
          )
          this.hide()
          this.$emit('reload')
          return
        }
        this.$bvToast.toast( 'Não foi possível vincular o agente aos cargos selecionados. Verifique as informações e tente novamente.',
          {
            title: 'Erro',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 4000
          }
        )
      } catch (e) {
        this.$bvToast.toast('ão foi possível vincular o agente aos cargos selecionados. Verifique as informações e tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.bind-product-roles {
  .header {
    .title {
      font-weight: 700;
      font-size: 20px;
      color: #262626;
    }
  }

  .roles {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(25%, auto));
    min-height: 80px
  }

  .divider {
    width: 100%;
    height: .5px;
    background: #C0C0C0;
  }
}

.sectors {
  .title {
    font-weight: 700;
    font-size: 17px;
    color: #262626;
  }

  .sector-name {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
  }

  .role-name {
    font-weight: 500;
    font-size: 15px;
    color: #000000;
  }

  .line {
    border-left: 1px solid #9C9C9C;
  }

  .product-name {
    font-weight: 400;
    font-size: 15px;
    color: #000000;
  }
}

.file-uploaded {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  color: var(--navy-blue);
  border: 1px solid var(--navy-blue);

  padding: 6px 12px;

  border-radius: 4px;

  transition: all 0.2s ease-in-out;

  text-decoration: none;

  cursor: pointer;
}

.file-product {
  border-radius: 6.25px;
  border: 1px dashed #808080;
  width: 100%;
  height: 40px;
  cursor: pointer;

  span {
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}

.agent-label {
  color: #262626;
  font-size: 16px;
  font-weight: 700;
}

.agent-value {
  font-size: 15px;
  color: #262626;
}

.agent-risk-block {
  padding: 14px 16px;
  display: flex;
  align-items: center;

  &--right {
    flex: 0 0 auto;
    justify-content: center;
  }

  &.agent-risk-header--chemical {
    background: rgba(4, 168, 243, 0.4);
  }

  &.agent-risk-header--physical {
    background: #CCE5D2;
  }

  &.agent-risk-header--biological {
    background: #E3BEB0;
  }
}

.agent-risk-row .agent-risk-block:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.agent-risk-row .agent-risk-block:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.agent-risk-text {
  font-weight: bold;
  font-size: 18px;
  color: #262626;
}

.selected-roles-summary {
  border-top: 1px solid #ededed;
  padding-top: 8px;
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.label {
  margin-bottom: -8px !important;
  font-weight: 700 !important;
}

.btn-to-link-role {
  border-radius: 6.25px !important;
  background: #04A8F3;

  span {
    color: #FFFFFF;
    font-weight: 600;
  }

  border: none;
}

.degreeOfDust {
  border: 1px solid var(--border-input);
  border-radius: 4px;
  padding: 10px;
}

.products-title {
  color: #262626;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.products-sub-title {
  color: #808080;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0;
}

.product {
  border-radius: 10px;
  border: 1px solid var(--navy-blue);
  padding: 5px;
  margin: 12px 12px 0 0;
}

.product-name {
  color: var(--navy-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.product-agent {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.sector-bind {
  border-top: 1px solid #C0C0C0;

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #022245;
  }

  .sector-name {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    margin-left: 40px;
  }
}

.obs {
  display: flex;
  align-items: center;
  justify-content: start;
  background: rgba(4, 168, 243, 0.4);
  border-radius: 6.25px;
  padding: 10px;

  span {
    font-weight: 400;
    font-size: 15px;
  }

  a {
    font-weight: 700;
    font-size: 15px;
    text-decoration: underline;
    color: #022245;
  }
}

.table-form {
  width: 100%;
  border-collapse: separate;
}

.table-form th {
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  color: #222;
  padding-bottom: 4px;
}

.table-form td {
  vertical-align: top;
}

.table-form input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #808080;
  color: #262626;
  outline: none;
}

.table-form input:focus {
  border-color: #5b9cff;
}

.table-form input.error {
  border: 1px solid #ff3b30;
}
</style>
